import * as React from "react";
import { KeyboardDateTimePicker } from "@material-ui/pickers";
import { KeyboardDatePicker } from "@material-ui/pickers";
import { InputAdornmentProps } from '@material-ui/core/InputAdornment';
import { SvgIcon } from "../../../../components";
import { tl } from "../../../../utils";
import * as styles from "./styles.scss";
import "moment/locale/ru";
import * as moment from "moment";
moment.locale("ru");

interface IProps {
  value: string;
  onChange: (value: any) => void;
  disabled?: boolean;
  fullWidth?: boolean;
  disablePast?: boolean;
  strictCompateDates?: boolean;
  dateOnly?: boolean;
  placeholder?: string;
  required?: boolean;
  isError?: boolean;
  minDate?: Date;
  maxDate?: Date;
  autoComplete?: string;
}

export const MUIDateTimePicker = (props: IProps) => {
  const selectedDate = props.value ? new Date(props.value) : null;
  return props.dateOnly ? (
    <KeyboardDatePicker
      value={selectedDate}
      onChange={props.onChange}
      disabled={props.disabled}
      disablePast={props.disablePast && !props.disabled}
      strictCompareDates={props.strictCompateDates}
      format="DD.MM.YYYY"
      keyboardIcon={<SvgIcon type="datepicker" />}
      inputVariant="outlined"
      okLabel={tl("ОК")}
      cancelLabel={tl("Отмена")}
      clearLabel={tl("Очистить")}
      todayLabel={tl("Сейчас")}
      placeholder={props.placeholder ? tl(props.placeholder) : tl("Выберите дату")}
      invalidDateMessage={tl("Неправильный формат даты/времени")}
      maxDateMessage={tl("Выбранная дата не должна привышать максимальную")}
      minDateMessage={tl("Выбранная дата не должна быть меньше минимальной")}
      fullWidth={props.fullWidth}
      className={styles.dtPicker}
      required={props.required}
      error={props.isError}
      minDate={props.minDate}
      maxDate={props.maxDate}
      autoComplete={props.autoComplete}
    />
  ) : (
    <KeyboardDateTimePicker
      value={selectedDate}
      onChange={props.onChange}
      disabled={props.disabled}
      disablePast={props.disablePast && !props.disabled}
      strictCompareDates={props.strictCompateDates}
      format="DD.MM.YYYY HH:mm"
      keyboardIcon={<SvgIcon type="datepicker" />}
      inputVariant="outlined"
      okLabel={tl("ОК")}
      placeholder={props.placeholder ? tl(props.placeholder) : tl("Выберите дату")}
      cancelLabel={tl("Отмена")}
      clearLabel={tl("Очистить")}
      todayLabel={tl("Сейчас")}
      invalidDateMessage={tl("Неправильный формат даты/времени")}
      maxDateMessage={tl("Выбранная дата не должна привышать максимальную")}
      minDateMessage={tl("Выбранная дата не должна быть меньше минимальной")}
      ampm={false}
      fullWidth={props.fullWidth}
      className={styles.dtPicker}
      minDate={props.minDate}
      maxDate={props.maxDate}
      autoComplete={props.autoComplete}
    />
  );
};
